export { default } from './ChevronRight'
